<template>
	<b-dropdown class="block__dropdown" trigger="click" position="is-bottom-left" v-if="permissionEnabled('users', 'edit') || permissionEnabled('users', 'delete')">
		<svg-icon class="dots" slot="trigger" icon="dots"></svg-icon>
		<b-dropdown-item v-for="(l, i) in items" :key="i" :class="l.color ? l.color : 'has-text-grey-light'" v-show="showButtons(l)" @click="handleClick(l, id)">
				<svg-icon :icon="l.icon"></svg-icon>
				<span>{{ $t(l.name) }}</span>
		</b-dropdown-item>
	</b-dropdown>
</template>
<script>
import Icon from '@/components/Icon'
import eventHub from '@/services/eventHub'
import { mapGetters } from 'vuex'

export default {
	name: 'Trigger',
	components: {
		'svg-icon': Icon
	},
	props: {
		id: {
			type: [Number, String],
			required: true
		},
		role: {
			type: String,
			required: true
		},
		active: {
			type: [Boolean, Number],
			required: true
		},
		name: {
			type: String,
			required: true
		},
		email: {
			type: String,
			required: true
		},
		delete: {
			type: Boolean,
			default: false
		},
		items: {
			type: Array,
			required: false,
			default: () => {
				return [
					{
						id: 1,
						name: 'edit',
						icon: 'edit',
						type: 'edit'
					},
					{
						id: 2,
						name: 'restore',
						icon: 'restore',
						color: 'has-text-info',
						type: 'edit'
					},
					{
						id: 3,
						name: 'disable',
						icon: 'restore',
						color: 'has-text-info',
						type: 'edit'
					},
					{
						id: 4,
						name: 'activate',
						icon: 'restore',
						color: 'has-text-info active',
						type: 'edit'
					},
					{
						id: 5,
						name: 'delete',
						icon: 'trash',
						color: 'has-text-danger',
						type: 'delete'
					}
				]
			}
		}
	},
	methods: {
		handleClick(el, id) {
			const name = el.id
			if (name === 1) {
				eventHub.$emit('edit-modal-users', {
					id,
					root: this.role
				})
			} else if (name === 5) {
				eventHub.$emit('delete-users', {
					id
				})
			} else if (name === 4) {
				eventHub.$emit('restore-users', {
					id
				})
			} else if (name === 3) {
				eventHub.$emit('disable-users', {
					id
				})
			}
		},
		showButtons(item) {
			let show = false

			if (this.permissionEnabled('users', item.type)) {
				show = true
			}

			if (item.name == 'Restaurar' && !this.delete) {
				show = false
			}

			if (item.name == 'Ativar' && this.active || item.name == 'Desativar' && !this.active) {
				show = false
			}

			if (this.email === 'wallace.erick@orbital.company' || this.email === 'vinicius.luiz@orbital.company' && item.type == 'delete') {
				show = false
			}

			return show
		}
	},
	computed: {
		...mapGetters('user', ['permissionEnabled'])
	}
}
</script>
